/**
 * Created by plamen on 11-May-17.
 */

import { LoaderEvent } from "../events/LoaderEvent";
import { BaseLoader } from "./BaseLoader";

export class VideoLoader extends BaseLoader {
    private _video: HTMLVideoElement = null;

    constructor(src: string, cacheTimestamp?: string, prependURL?: string, id?: string) {
        super(src, cacheTimestamp, prependURL, id);
    }

    getData(): any {
        return this._video;
    }

    protected getResponseType(): string {
        return "blob";
    }

    protected onLoaded(event?: any)
    {
        this._video = document.createElement("video");
        this._video.setAttribute('playsinline', '')
        this._video.setAttribute('preload', 'auto')
        this._video.setAttribute('autoplay', 'autoplay')
        this._video.setAttribute('crossorigin','anonymous')
        this._video.setAttribute('role','application')
        this._video.setAttribute('muted', 'muted')
        let source = document.createElement('source')
        this._video.appendChild(source)
        // Video is now downloaded
        // and we can set it as source on the video element
        source.src = URL.createObjectURL(this._request.response);
        

        // All these events are dispatched because of iOS Safari loading issue
        this._video.onloadedmetadata = () => {this.onCanPlay()}
        this._video.onloadeddata  = () => {this.onCanPlay()}
        this._video.onprogress  = () => {this.onCanPlay()}
        this._video.oncanplay  = () => {this.onCanPlay()}
        this._video.onloadstart  = () => {this.onCanPlay()}

        this._video.onerror = this.onDecodeError.bind(this);
    }

    protected onCanPlay() {
        this._video.pause();
        this._video.currentTime = 0;

        this._video.onloadedmetadata = null
        this._video.onloadeddata  = null
        this._video.onprogress  = null
        this._video.oncanplay  = null
        this._video.onloadstart  = null

        this._video.width = this._video.videoWidth;
        this._video.height = this._video.videoHeight;

        this.dispatchEvent(new LoaderEvent(LoaderEvent.COMPLETE));
    }

    protected onDecodeError() {
        this.dispatchEvent(new LoaderEvent(LoaderEvent.DECODE_ERROR));
    }

    protected onError(event: any) {
        this.dispatchEvent(new LoaderEvent(LoaderEvent.ERROR));
    }
}
